import IAuthentication from "../core/contracts/IAuthentication";
import User from "../core/models/User";
import BaseService from "./BaseService";
import { encodeStringToBase64 } from "../helpers/utility";
import IResetPassword from "../core/contracts/IResetPassword";
import IAuthenticationResponse from "../core/contracts/IAuthenticationResponse";
import Runtime from "../helpers/Runtime";

export default class AuthenticationService extends BaseService {
  async doLogin(form: IAuthentication): Promise<User> {
    try {
      let auth: IAuthentication;
      // eslint-disable-next-line prefer-const
      auth = {
        username: form.username,
        password: encodeStringToBase64(form.password),
      };
      const user = await new BaseService(true, false, false).post<User, IAuthentication>(
        "/core/auth/login",
        auth
      );
      const runtime = new Runtime();
      new BaseService(true).logAndShip("info", "User successfully logged in", {
        userEmail: form.username,
        platform: runtime.isMobile() ? "Mobile" : "Web",
        version: "v 1." + process.env.REACT_APP_VERSION?.toString(),
      });
      return user;
    } catch (error) {
      const runtime = new Runtime();
      new BaseService(true).logAndShip("warn", "AuthenticationService -> doLogin -> error", {
        userEmail: form.username,
        platform: runtime.isMobile() ? "Mobile" : "Web",
        version: "v 1." + process.env.REACT_APP_VERSION?.toString(),
      });
      // eslint-disable-next-line no-console
      console.warn("AuthenticationService -> doLogin -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async testBearer(): Promise<boolean> {
    try {
      return await new BaseService(true).get<boolean>("/core/auth");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("AuthenticationService -> testBearer -> error", error.data);
      return Promise.reject(error);
    }
  }

  async alterPassword(newAuthenticationData: IResetPassword): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, IResetPassword>(
        "/core/Auth/reset",
        newAuthenticationData
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("AuthenticationService -> alterPassword -> error", error);
      return Promise.reject(error);
    }
  }

  async renewToken(): Promise<IAuthenticationResponse> {
    try {
      return await new BaseService(true).get("/core/auth/UpdateToken");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("AuthenticationService -> renewToken -> error", error);
      return Promise.reject(error);
    }
  }
}
